import { getReferenceOptionsDocumentTypeByCountry } from 'utilities/multiLanguageHelper';

export const getDocumentTypeLabelKey = documentType =>
    getReferenceOptionsDocumentTypeByCountry().find(({ value }) => documentType === value)?.label;
